module.exports = __webpack_public_path__ + "static/media/question.e6e5d731.mp3";